import { Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Typography } from '@mui/material'
import { Container } from 'Components/Container'
import { Column } from 'Components/Grid'
import { useQuery } from 'react-query'
import { useNavigate, useParams } from 'react-router-dom'
import { ColumnEdit, LinkEdit, RowExhibition } from './styles'
import EditOutlinedIcon from '@mui/icons-material/EditOutlined'
import { PageLoaderShow } from 'Components/PageLoader/Show'
import { getUsersGroupById, getUsersGroupUsers } from 'services/users-groups-service'

export const UsersGroupsShow = () => {
    const navigate = useNavigate()
    const { id } = useParams()

    const { isLoading, error, data: userGroup } = useQuery('getUserGroupById', async () => {
        if (!id) return null
        const dataUserGroup = await getUsersGroupById(id)

        return (dataUserGroup.status === 200) ? dataUserGroup.data : null
    })

    const { isLoading: isLoadingUsers, data: groupUsers } = useQuery(['getUsersGroupUsers', id], async () => {
        if (!id) return []
        const response = await getUsersGroupUsers(id)
        return (response.status === 200) ? response.data : []
    })

    const onClickEdit = () => {
        navigate('/users-groups/edit/'+id)
    }

    return (
        <>
            {!isLoading && !error && (
                <Container
                    title={`${userGroup?.name}`}
                    breadcrumb={`Gerenciar / Grupos de usuários / ${userGroup?.name}`}
                    linkPage="/users-groups"
                >
                    <Box sx={{ width: '100%' }} className="container">
                        <Box sx={{ p: 3 }}>
                            <RowExhibition>
                                <Column xs={3}>Nome</Column>
                                <Column>{userGroup.name}</Column>
                                <ColumnEdit xs={2}>
                                    <LinkEdit onClick={onClickEdit}>
                                        <EditOutlinedIcon style={{ fill: '#0039C5' }} />
                                        Editar
                                    </LinkEdit>
                                </ColumnEdit>
                            </RowExhibition>
                            <RowExhibition>
                                <Column xs={3}>Ativo</Column>
                                <Column>{userGroup.active ? 'Sim' : 'Não'}</Column>
                                <ColumnEdit xs={2}>
                                    <LinkEdit onClick={onClickEdit}>
                                        <EditOutlinedIcon style={{ fill: '#0039C5' }} />
                                        Editar
                                    </LinkEdit>
                                </ColumnEdit>
                            </RowExhibition>
                        </Box>

                        <Box sx={{ p: 3, mt: 2 }}>
                            <Typography variant="h6" sx={{ mb: 2 }}>
                                Usuários do Grupo
                            </Typography>
                            {isLoadingUsers ? (
                                <Typography>Carregando usuários...</Typography>
                            ) : (
                                <TableContainer component={Paper}>
                                    <Table>
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>Nome</TableCell>
                                                <TableCell>Email</TableCell>
                                                <TableCell>Tipo</TableCell>
                                                <TableCell>Status</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {groupUsers && groupUsers.length > 0 ? (
                                                groupUsers.map((user) => (
                                                    <TableRow key={user._id}>
                                                        <TableCell>{user.name}</TableCell>
                                                        <TableCell>{user.email}</TableCell>
                                                        <TableCell>{user.type}</TableCell>
                                                        <TableCell>{user.active ? 'Ativo' : 'Inativo'}</TableCell>
                                                    </TableRow>
                                                ))
                                            ) : (
                                                <TableRow>
                                                    <TableCell colSpan={4} align="center">
                                                        Nenhum usuário neste grupo
                                                    </TableCell>
                                                </TableRow>
                                            )}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            )}
                        </Box>
                    </Box>
                </Container>
            )}
            {isLoading && <PageLoaderShow />}
            {error && <div>Erro</div>}
        </>
    )
}
